import * as React from "react";
import { forwardRef } from "react";
const SvgPause = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 4, y: 1.33334, width: 2.05128, height: 13.3333, rx: 0.5, fill: "currentColor" }), /* @__PURE__ */ React.createElement("rect", { x: 10.1539, y: 1.33334, width: 2.05128, height: 13.3333, rx: 0.5, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgPause);
export default ForwardRef;
